import * as types from "../constants/actionConstants";
import {debugLog} from "../utilities/debugLogger";

const initialState = {
    loggedIn: false,
    message: "",
    loading: false,
    username: "",
    showWelcomeMessage: false
};

function loginReducer(state = initialState, action) {
    const prevLoggedIn = state.loggedIn;
    let nextState;
    switch (action.type) {
        case types.TOKEN_GET:
            nextState = {
                loggedIn: false,
                loading: true,
                message: "",
                username: action.rememberMe? action.username : ""
            };
            break;

        case types.TOKEN_SET:
            nextState = {
                loggedIn: true,
                loading: false,
                message: "",
                username: state.username,
                showWelcomeMessage: true
            };
            break;

        case types.TOKEN_CLEAR:
        case types.TOKEN_REJECT_LOGIN:
            nextState = {
                loggedIn: false,
                loading: false,
                message: action.message,
                username: state.username,
                showWelcomeMessage: false
            };
            break;

        case types.TOKEN_INITIALIZE:
            nextState = {
                ...state,
                ...action.payload
            };
            break;

        default:
            nextState = state;
    }
    if (nextState !== state) {
        debugLog('AUTH','Action ' + action.type + ' loggedIn ' + prevLoggedIn + ' -> ' + nextState.loggedIn, {message: nextState.message});
    }
    return nextState;
}

export default loginReducer;
